import { useMsal } from '@azure/msal-react';
import FormGroup from '@material-ui/core/FormGroup';
import Grid from '@material-ui/core/Grid';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';
import React, { ReactElement, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { getKonfig, selectDateKonfig, updateKonfig } from "./konfigurationSlice";
import { useStyles } from "./konfigurationStyles";

export default function DateSwitch(): ReactElement {

    const dispatch = useAppDispatch();
    const { instance } = useMsal();

    useEffect(() => {
        dispatch(getKonfig());
    }, [instance]);

    const classes = {
        ...useStyles(),
    };

    const konfig = useAppSelector(selectDateKonfig);

    return (
        <div>
            <FormGroup style={{ marginRight: "40px" }}>
                <Typography component="div" className={classes.switchButton}>
                    <Grid component="label" container alignItems="center" spacing={1}>
                        <Grid item style={{fontSize:"16px", fontWeight:"500"}}> Lokale Zeit</Grid>
                        <Grid item>
                            <Switch
                                value={JSON.parse(konfig.wert)}
                                checked={JSON.parse(konfig.wert)}
                                className={classes.toggle}
                                onChange={(e) =>
                                    dispatch(updateKonfig(konfig, e.target.checked.toString()))
                                }
                            />
                        </Grid>
                        <Grid item style={{fontSize:"16px", fontWeight:"500"}} >UTC</Grid>
                    </Grid>
                </Typography>
            </FormGroup>
        </div>
    );
}
